import React from 'react';
import PropTypes from 'prop-types';
import { Image, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';
import { useTranslation } from 'react-i18next';
import Tag from '../../Atoms/Tag';

import './style.scss';

const Card = ({
  title,
  body,
  image,
  alt,
  type,
  subType,
  link,
  created,
  small,
  status,
}) => {
  const { t, i18n } = useTranslation();
  const tagText = i18n.exists(`tags.${subType.toLowerCase()}`)
    ? t(`tags.${subType.toLowerCase()}`)
    : subType;

  const date = created ? new Date(created * 1000) : null;
  const dateString = date && `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  switch (type) {
    case 'article':
    case 'tool':
    case 'expert':
    case 'e_learning':
    case 'interventie':
    case 'vacature':
      return (
        <div
          className={`Card Card-article Card-type-${subType.toLowerCase()} Card-variant-${type.toLowerCase()} ${small ? 'Card-small' : ''}`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              icon={type === 'article' || type === 'news' ? 'copy' : 'gear'}
              className={image ? 'Tag-image' : ''}
            />
            {(created && ((type === 'article' && subType === 'news') || type === 'news')) && <div className="created">{dateString}</div>}
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {body && (
              <div className="body subheading2">
                <WysiwygField property="schema:text" html={body} />
              </div>
            )}
          </div>
        </div>
      );
    case 'news':
      return (
        <div
          className={`Card Card-news Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              icon="board"
              className={image ? 'Tag-image' : ''}
            />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
    case 'download':
    case 'onderzoek':
      return (
        <div
          className={`Card Card-download Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              icon={type === 'download' ? 'download' : 'light'}
              className={image ? 'Tag-image' : ''}
            />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {status && <div className="pubDate">{status}</div>}
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
    case 'praktijkvoorbeeld':
    case 'event':
      return (
        <div
          className={`Card Card-event Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              icon={type === 'event' ? 'book' : 'board'}
              className={image ? 'Tag-image' : ''}
            />
            <div className="title">
              <CoreLink href={link}>{title}</CoreLink>
            </div>
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
    case 'landing_page':
      return (
        <div
          className={`Card Card-page Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag text={tagText} className={image ? 'Tag-image' : ''} />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
    case 'milestones':
      return (
        <div
          className={`Card Card-article Card-type-${type.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={t(`tags.${type.toLowerCase()}`)}
              icon="copy"
              className={image ? 'Tag-image' : ''}
            />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            <Tag text={subType} className="label" />
            {body && (
              <div className="body subheading2">
                <WysiwygField property="schema:text" html={body} />
              </div>
            )}
          </div>
        </div>
      );
    case 'campaign':
    case 'subject':
    case 'workfield':
      return (
        <div
          className={`Card Card-article Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              className={image ? 'Tag-image' : ''}
            />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
    default:
      return (
        <div
          className={`Card Card-article Card-type-${subType.toLowerCase()} ${
            small ? 'Card-small' : ''
          }`}
        >
          {image && (
            <div className="image">
              <Image includeWebP src={image} alt={alt} />
            </div>
          )}
          <div className="info">
            <Tag
              text={tagText}
              icon={type === 'article' || type === 'news' ? 'copy' : 'tool'}
              className={image ? 'Tag-image' : ''}
            />
            <CoreLink href={link} className="title teaser-link">{title}</CoreLink>
            {body && <div className="body">{body}</div>}
          </div>
        </div>
      );
  }
};

Card.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.string,
  image: PropTypes.string,
  alt: PropTypes.string,
  type: PropTypes.oneOf([
    'article',
    'tool',
    'expert',
    'e_learning',
    'interventie',
    'vacature',
    'news',
    'download',
    'onderzoek',
    'praktijkvoorbeeld',
    'event',
    'landing_page',
    'milestones',
    'campaign',
    'subject',
    'workfield',
  ]),
  subType: PropTypes.string,
  link: PropTypes.string.isRequired,
  created: PropTypes.number,
  small: PropTypes.bool,
  status: PropTypes.string,
};

Card.defaultProps = {
  body: '',
  image: '',
  alt: '',
  type: '',
  subType: 'other',
  created: null,
  small: false,
  status: '',
};

export default Card;
